/**
 * 
 * @param {Array<String>} tags 
 */
export default class LostPetsUtils
{
    static tagsToStateString (tags)
    {
        var state = tags.includes('found') ? 'perdu' : 'trouvé'
        if (tags.includes('to-adopt')) state = 'à adopter'
    
        return state
    }
}


// WEBPACK FOOTER //
// ./src/utils/lostPetsUtils.js